/**
 * 选择儿童就餐人数
 */
import React from 'react'
import { observer } from 'mobx-react'
import { Icon } from '@cps'
import { classNames } from '@dt/fe-utils'
import './index.scss'

import ertongImg from '@img/ertong.png'

interface IProps {
  kidNum?: number;
  height?: number;
  hasKids: boolean;
  handle: (type: string, value: number) => void;
}

const SelectKids: React.FC<IProps> = ({ kidNum = 0, height = 1, handle, hasKids = false }) => {
  if (!hasKids) return null
  const kidOptions = new Array(5).fill('')
  const handleSelect = (value: number) => {
    handle('kids', value)
  }
  return (
    <div className='select-person-container'>
      <div className='select-icon-wrap'>
        <img className='kid-img' src={ertongImg} />
        <span className='kids-tips'>{i18n.t('menu.kidsStandard', { height })}</span>
      </div>
      <div className='select-person-wrapper'>
        {
          kidOptions.map((key, index) => {
            const value = index + 1
            const isActive = kidNum === value
            return <div className={classNames('item', { active: isActive })} onClick={() => handleSelect(isActive ? 0 : value)} key={value}>{value}</div>
          })
        }
      </div>
    </div>
  )
}

export default observer(SelectKids)
